export default (theme) => {
    return {
        root: {
            display: 'flex',
            flexFlow: 'column nowrap',
            backgroundColor: theme.colors.primary.white,
            boxShadow: theme.effects.boxShadow,
            borderRadius: 8,
            padding: 16,
            maxWidth: '100%',
            maxHeight: '50vh',
            width: 300,
            overflow: 'hidden',
        },
        item: {
            display: 'flex',
            flexFlow: 'row nowrap',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: 8,
            cursor: 'pointer',
            padding: '4px 8px',
            boxSizing: 'border-box',
            borderRadius: 4,
        },
        selected: {
            backgroundColor: theme.colors.grey[50],
        },
        advice: {
            marginBottom: 16,
        },
        avatar: {
            flexShrink: 0,
        },
        name: {
            display: 'inline-block',
        },
        isEmpty: {
            opacity: 0,
            pointerEvents: 'none',
        },
    };
};
